import type { PropsWithChildren } from 'react';

export function Badge({ variant, children }: PropsWithChildren<{ variant?: string }>) {
  return <span className={`badge ${variant ?? ''}`}>{children}</span>;
}

export function StatusBadge({ status }: { status: string }) {
  const map: Record<string, string> = {
    available: 'b-avail',
    deployed: 'b-deployed',
    unavailable: 'b-unavail',
    live: 'b-live',
    completed: 'b-completed',
    upcoming: 'b-pending',
    cancelled: 'b-cancelled',
    paused: 'b-pending',
  };
  return <Badge variant={map[status] ?? ''}>{status}</Badge>;
}

export function CertStatusBadge({ status }: { status: 'valid' | 'expiring' | 'expired' | string }) {
  const map: Record<string, string> = { valid: 'b-valid', expiring: 'b-expiring', expired: 'b-expired' };
  return <Badge variant={map[status] ?? ''}>{status}</Badge>;
}

export function ContactTypeBadge({ type }: { type: string }) {
  const cls = `b-type-${type.toLowerCase()}`;
  return <Badge variant={cls}>{type}</Badge>;
}

export function ComplianceBadge({ compliance }: { compliance: string }) {
  const map: Record<string, string> = { compliant: 'b-compliant', pending: 'b-pending', 'non-compliant': 'b-noncompliant' };
  return <Badge variant={map[compliance] ?? ''}>{compliance}</Badge>;
}

export function CoreBadge({ core }: { core: boolean }) {
  if (!core) return null;
  return <span className="core-badge">★ CORE</span>;
}
